import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useSelector } from 'react-redux';

import BarChart4BarsIcon from '@/material-icons/400-24px/bar_chart_4_bars.svg?react';
import PhotoLibraryIcon from '@/material-icons/400-24px/photo_library.svg?react';
import { Avatar } from 'flavours/glitch/components/avatar';
import { Icon } from 'flavours/glitch/components/icon';
import { Permalink } from 'flavours/glitch/components/permalink';
import { EmbeddedStatusContent } from 'flavours/glitch/features/notifications_v2/components/embedded_status_content';
import { SharlayanReplyIndicatorHeader } from 'flavours/glitch/sharlayan/compose/reply_indicator_header';

export const ReplyIndicator = ({ isInline }) => {
  const inReplyToId = useSelector(state => state.getIn(['compose', 'in_reply_to']));
  const status = useSelector(state => state.getIn(['statuses', inReplyToId]));
  const account = useSelector(state => state.getIn(['accounts', status?.get('account')]));

  if (!status) {
    return null;
  }

  return (
    <div className='reply-indicator'>
      <div className='reply-indicator__line' />

      <Permalink href={account.get('url')} to={`/@${account.get('acct')}`} className='detailed-status__display-avatar'>
        <Avatar key={`avatar-${account.get('id')}`} account={account} size={46} />
      </Permalink>

      <div className='reply-indicator__main'>
        <SharlayanReplyIndicatorHeader account={account} isInline={isInline} />

        <EmbeddedStatusContent
          className='reply-indicator__content translate'
          status={status}
        />

        {(status.get('poll') || status.get('media_attachments').size > 0) && (
          <div className='reply-indicator__attachments'>
            {status.get('poll') && <><Icon icon={BarChart4BarsIcon} /><FormattedMessage id='reply_indicator.poll' defaultMessage='Poll' /></>}
            {status.get('media_attachments').size > 0 && <><Icon icon={PhotoLibraryIcon} /><FormattedMessage id='reply_indicator.attachments' defaultMessage='{count, plural, one {# attachment} other {# attachments}}' values={{ count: status.get('media_attachments').size }} /></>}
          </div>
        )}
      </div>
    </div>
  );
};

ReplyIndicator.propTypes = {
  isInline: PropTypes.bool,
};
